import { Grid, Typography } from "@mui/material";
import { ReactElement } from "react";

type Props = {
  label: string;
  field: ReactElement;
};

const InputRow = ({ label, field }: Props) => {
  return (
    <>
      <Grid item xs={2} justifyContent="flex-end" alignItems="center">
        <Typography textAlign="right">{label}</Typography>
      </Grid>
      <Grid item xs={10} justifyContent="flex-end" alignItems="center">
        {field}
      </Grid>
    </>
  );
};

export default InputRow;
